import { BaseModel } from '@Core';
import { Camera } from './Camera';
import { Location } from './Locations';
import { PotentialContraventions } from './PotentialContraventions';
import { ServiceSM } from './ServiceSM';

export interface StatisticPotentialContraventionByZone extends Zones {
    TotalStepOne: number;
    TotalStepTwo: number;
    TotalWip: number;
    PotentialContraventions?: PotentialContraventions[];
}

export interface ZoneSM extends BaseModel {
    LocationId: number;
    Location?: Location;

    Name: string;

    PublicName: string;

    ExternalReference: string;

    TotalBays: number;

    Notes: string;
    Services?: ServiceSM[];
}

export interface Zones extends ZoneSM {
    IsReadyToGenPotentialContravention: boolean;

    IsReadyServiceEcam: boolean;

    Cameras?: Camera[];

    Priority: ZonePriority;
}

export enum ZonePriority {
    P0,
    P1,
    P2,
    P3,
    P4,
    P5,
    P6,
}
